module.exports = __webpack_public_path__ + "img/5.b70eb1c4.jpg";